import * as React from "react";
import {
  WithStyles,
  withStyles,
  StyleRulesCallback
} from "@material-ui/core/styles";

interface IProps {
  href: string;
  openInSameTab?: boolean;
}

const styles: StyleRulesCallback = ({ palette, spacing }) => ({
  root: {
    color: "inherit"
  }
});

@(withStyles(styles) as any)
export default class JobsLink extends React.Component<
  IProps & Partial<WithStyles<any>>
> {
  public render() {
    const { classes, href, openInSameTab } = this.props;
    const target = openInSameTab ? undefined : "_blank";
    return (
      <a className={classes!.root} href={href} target={target}>
        {this.props.children}
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/JobsLink.tsx